<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog">
        <div class="cart-popup__content payment">
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            
           
            <div>
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2023/07/0724_PF23_sgp/activity_sgp01.jpg"
                alt="2023 NEW EMERALD SPECIAL WORKSHOP SINGAPORE / 액티비티 정보 안내 - 안녕하세요? 신나는 즐길거리와 먹거리가 가득한 도시, 무궁무진한 매력을 가진 싱가포르! 2023 싱가포르 뉴 에메랄드 스페셜 워크샵의 액티비티 신청 페이지가 9월 4일(월)에 오픈됩니다! 액티비티를 신청하시는 리더님들을 위해 액티비티 정보를 안내 드립니다.">
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2023/07/0724_PF23_sgp/activity_sgp02.jpg"
                alt="OPTION 1 유니버셜 스튜디오 - 동남아시아 최초, 최고의 할리우드 영화 테마파크로 신나는 어트랙션들과 각 종 영화 캐릭터들을 만날 수 있는 싱가포르 필수 여행코스, 슈렉, 트랜스포머, 미니언즈, 쥬라기공원, 미이라 등의 할리우드 영화 어트랙션과 함께 스트레스를 모두 날려버리고 수많은 인생샷도 건져보세요. / 이런 리더님께 추천드립니다! - 놀이기구를 좋아한다!, 할리우드 영화를 좋아한다!, 싱가포르에 왔으면 유니버셜 스튜디오는 가봐야한다!">
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2023/07/0724_PF23_sgp/activity_sgp03.jpg"
                alt="OPTION 2 오감만족 싱가포르 핫트팟 투어(팀랩 퓨쳐월드, 호텔 애프터눈 티, 가든스 바이 더 베이) - 세계적으로 유명한 디지털 아트 그룹인 팀랩의 전시를 싱가포르에서 만나보세요. 인스타그램 인증샷으로 MZ 세대에서 핫한 팀랩 퓨쳐월드 전시 관람 후 럭셔리한 플러턴 베이 호텔에서 마리나 베이를 조망하며
                                애프터눈 티를 즐길 수 있습니다. 충분한 티타임을 즐기신 후 세계 최대 온실을 보유한 가든스 바이 더 베이에서 쾌적하게 전 세계의 아름다운 꼬초가 식물을 만나보시기 바랍니다. / 이런 리더님께 추천드립니다! - 여유롭고 시원하게 힐링을 즐기고 싶다!, 인스타그램 인생샷을 건지고 싶다!, 놀이공원 보다는 우아한 티타임이 더 좋다!">
            </div>
          </div>
        </div>
        <div
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCAcmi_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SINGAPORE, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayerActivity',
  mixins: [PopupMixin],
  computed: {
    ...mapState(SURVEY_SINGAPORE, {
      pinLevel: state => state.pin_level,
      show: state => state.popup_activity,
    }),
    ...mapGetters(SURVEY_SINGAPORE, {
    }),
  },
  watch: {
    show(isOpen) {
      if(isOpen) {
        this.htmlEl.classList.add("scrollLock");
        this.uiLayerMask.classList.add("on");
        this.uiLayerMask.style.display = 'block';
        window.addEventListener('resize', this.layerTypeBasic);
        this.layerTypeBasic();
      } else {
        this.htmlEl.classList.remove("scrollLock");
        this.uiLayerMask.classList.remove("on");
        this.uiLayerMask.style.display = 'none';
        window.removeEventListener('resize', this.layerTypeBasic);
      }
    }
  },
  methods: {
    closePopup() {
      this.$store.commit(`${SURVEY_SINGAPORE}/${TOGGLE_ACTIVITY_POPUP}`, false);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyPopupLayerActivity.vue